<div class="row clearfix">
  <div class="col-6 col-md-4 col-xl-4">
    <div class="card">
      <div class="card-body ribbon">
        <a
          href="#"
          class="my_sort_cut text-muted"
          routerLink="/project/{{ projectId }}/schedule-update"
          ><i class="fa fa-calendar"></i><span>Schedule Update</span></a
        >
      </div>
    </div>
  </div>
  <div class="col-6 col-md-4 col-xl-4">
    <div class="card">
      <div class="card-body ribbon">
        <a
          href="#"
          class="my_sort_cut text-muted"
          routerLink="/project/{{ projectId }}/anticipated-budget-form"
          ><i class="fa fa-usd"></i><span>Update Anticipated Budget</span></a
        >
      </div>
    </div>
  </div>
  <div class="col-6 col-md-4 col-xl-4">
    <div class="card">
      <div class="card-body ribbon">
        <a
          href="#"
          class="my_sort_cut text-muted"
          routerLink="/project/{{ projectId }}/monthly-payments"
          ><i class="fa fa-money"></i><span>Monthly Payment Update</span></a
        >
      </div>
    </div>
  </div>
  <div class="col-6 col-md-4 col-xl-4">
    <div class="card">
      <div class="card-body ribbon">
        <a
          href="#"
          class="my_sort_cut text-muted"
          routerLink="/project/{{ projectId }}/issue-form"
          ><i class="fa fa-question"></i><span>Report Issue</span></a
        >
      </div>
    </div>
  </div>
</div>
